import React, {Fragment}  from 'react';
import { connect } from "react-redux";
import moment from 'moment';
import Select from 'react-select';
import Creatable from 'react-select/lib/Creatable';
import DatePicker from 'react-datepicker';
import { FormText } from 'reactstrap';
import 'react-select/dist/react-select.css';
import {globals} from '../../../../common/constants';
import _ from 'lodash';
import { escapeRegExp } from "../../utils/utils";

//Images
import {
    removeAllImageUploads
} from "../../shared/redux/actions"
import Images from "../Images/Images";
import ReactTooltip from "react-tooltip";
import {isNonWorkingDay,is8BusinessDayBeforeReturnDate} from "../../helpers";
import {DAYS_UNTIL_READY} from "./constants";
const IMPLANT_IS_CHECKED = '1'

class addBookingForm extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            hasLicense: false,
            bridges:[],
            checkedTeeth:[],
            isTextareaFocused: false,
            isTextareaFocusedForAdmin: false,
            bridgesStructure: {
                top: {
                    left: {
                        '_13': {index: 5, number: 13}, '_14': {index: 4, number: 14}, '_15': {index: 3, number: 15}, '_16': {index: 2, number: 16}, '_17': {index: 1, number: 17}, '_18': {index: 0, number: 18},
                    },
                    center: {
                        '_12': {index: 6, number: 12}, '_11': {index: 7, number: 11}, '_21': {index: 8, number: 21}, '_22': {index: 9, number: 22},
                    },
                    right: {
                        '_23': {index: 10, number: 23}, '_24': {index: 11, number: 24}, '_25': {index: 12, number: 25}, '_26': {index: 13, number: 26}, '_27': {index: 14, number: 27}, '_28': {index: 15, number: 28},
                    },
                },
                bottom: {
                    left: {
                        '_48': {index: 0, number: 48}, '_47': {index: 1, number: 47}, '_46': {index: 2, number: 46}, '_45': {index: 3, number: 45}, '_44': {index: 4, number: 44}, '_43': {index: 5, number: 43},
                    },
                    center: {
                        '_42': {index: 6, number: 42}, '_41': {index: 7, number: 41}, '_31': {index: 8, number: 31}, '_32': {index: 9, number: 32},
                    },
                    right: {
                        '_38': {index: 15, number: 38}, '_37': {index: 14, number: 37}, '_36': {index: 13, number: 36}, '_35': {index: 12, number: 35}, '_34': {index: 11, number: 34}, '_33': {index: 10, number: 33},
                    },
                }
            }
        }
    }
    componentWillUnmount() {
        this.props.removeAllUploads();
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.dentistInfo !== this.props.dentistInfo){
            if(this.props.dentistInfo){
                const selectedDentistID = this.props.dentistInfo.value;
                const selectedDentistObj = this.props.dentistsAll && this.props.dentistsAll.find(obj => obj.id === selectedDentistID)
                this.setState({hasLicense: selectedDentistObj && selectedDentistObj.license ? selectedDentistObj.license : '' || this.props.hasLicense})
            }
        }
    }

    filterOptions(options, filter, currentValues) {
        if (filter) {
            return options.filter(option => {
                const regex = new RegExp("^" + escapeRegExp(filter.toLowerCase()));
                const names = option.label.match(/\S+/g);
                const filtered = names.filter(name => {
                    return name.toLowerCase().match(regex);
                }).length !== 0;
                return filtered ? filtered : option.label.toLowerCase().match(regex);
            });
        }
        return options;

    }
    getUnitKey(date) {
        const { listNumberOfUnits } = this.props;
        return Object.keys(listNumberOfUnits || {}).find((element) => {
            if (moment(date).format('YYYY-MM-DD') === element) {
                return listNumberOfUnits[element];
            } else {
                return false;
            }
        });
    }

    renderAvailableUnits() {
        const {selectedDate, listNumberOfUnits, specialDays, numberOfUnitsForPerDay} = this.props,
            unitsKey = this.getUnitKey(selectedDate),
            dayKey = moment(selectedDate).format('YYYY-MM-DD');
        let misc = globals.NUMBER_OF_UNITS_MISC,
            zirconia = globals.NUMBER_OF_UNITS_ZIRCONIA;

        if (numberOfUnitsForPerDay && !_.isEmpty(numberOfUnitsForPerDay)) {
            misc = numberOfUnitsForPerDay.units;
            zirconia =numberOfUnitsForPerDay.units_for_zirconia;
        } else if (unitsKey !== undefined) {
            misc = listNumberOfUnits[unitsKey].units;
            zirconia = listNumberOfUnits[unitsKey].units_for_zirconia;
        } else if (specialDays !== undefined && specialDays[dayKey] !== undefined) {
            misc = specialDays[dayKey].units;
            zirconia = specialDays[dayKey].units_for_zirconia || 0;
        }
        const isAvailable = ` Misc: ${misc} Zirconia/Ceramic: ${zirconia}`;
        const notAvailable = ` Misc: 0 Zirconia/Ceramic: 0`;
        return (
            <div>
                Available units:
                <span>{this.props.date_of_return ? isAvailable : notAvailable}</span>
            </div>
        )
    }

    getMinSubmissionDate() {
        let countDays = 0;
        let substractDays = DAYS_UNTIL_READY + 4;
        if(moment(this.props.dateOfReturnUTC).day() === 4 || moment(this.props.dateOfReturnUTC).day() === 5){
            substractDays = DAYS_UNTIL_READY + 2;
        }
        this.props.vacationDays && this.props.vacationDays.forEach((vacationDaysItem)=>{
            const returnDate = moment(this.props.dateOfReturnUTC);
            const subtractedReturnDate = moment(this.props.dateOfReturnUTC).subtract(substractDays,'days');

            const vacationStart = moment(vacationDaysItem.start);
            const vacationEnd = moment(vacationDaysItem.end);

            if(
                vacationEnd.isBetween(subtractedReturnDate, returnDate, 'days', '[]') &&
                !vacationStart.isBetween(subtractedReturnDate, returnDate, 'days', '[]')
            ){
                countDays+=(vacationEnd.diff(vacationStart,'days') + 1);
            }
            if(
                vacationStart.isBetween(subtractedReturnDate, returnDate, 'days', '[]')
            ) {
                if (vacationEnd.isBetween(subtractedReturnDate, returnDate, 'days', '[]')) {
                    countDays+=(vacationEnd.diff(vacationStart,'days') + 1);
                    return
                }
                countDays+=(returnDate.diff(vacationStart,'days') + 1)
            }
        })
        let minDate = null;
        if(this.props.isSubcase){
            minDate = moment(this.props.minDateForSubcase).subtract(12, 'days');
            return minDate;
        } else if(this.props.minSendingDate) {
            minDate = moment(this.props.date_of_return).subtract(
                // +countDays for vacation days, +2 days for the weekdays
                countDays ? substractDays + countDays : substractDays, 'days'
            )
            const minDateWeekday = minDate.day();

            // If it's sunday
            if (minDateWeekday === 0) {
                return minDate.subtract(2, 'days');
            }

            // If it's saturday
            if (minDateWeekday === 6) {
                return minDate.subtract(1, 'days');
            }

            return minDate;
        }
    }

    render() {
        const bridges =  this.props.isSubcase ? this.props.bridges : this.props.data.bridges
        return (
            <form>
                <div className="book">
                    <div className="book__block">
                        <div className="date">
                            <div className="date__today todays-date">
                                <div
                                    className="text-field date__field"
                                >
                                    <label className="text-field__label" htmlFor="">Date</label>
                                    <input
                                        type="text"
                                        className="text-field__input"
                                        placeholder="Date Of Submission"
                                        disabled={true}
                                        value={this.props.dateOfSubmittion}
                                    />
                                </div>
                            </div>
                            <div className="date__return return-date" check="true" inline="true">
                                {this.props.isSubcase || !this.props.selectedDate ?
                                    <div
                                        className={(this.props.validation.date_of_return) ? "react-calendar has-error" : "react-calendar"}
                                    >
                                        <label className='react-calendar__label'>Return Date <span className="asterisk">*</span></label>
                                        <div className="react-calendar__field">
                                            <DatePicker
                                                dayClassName={date => isNonWorkingDay(date,this.props.vacationDays) ? 'disabled_date' : ''}
                                                popperPlacement="bottom"
                                                ref="pickerReturn"
                                                className="datePickerInput custom-input"
                                                selected={this.props.data.date_of_return}
                                                onChange={(date) => this.props.handleChangeReturnDate(date)}
                                                placeholderText={"Select return date"}
                                                dateFormat="DD/MM/YYYY"
                                                minDate={this.props.isSubcase ? moment(this.props.minDateForSubcase).format("DD/MM/YYYY") : null}/>
                                            {this.props.validation.date_of_return &&
                                                <span className="error-message">{this.props.dateOfReturn || "Return Date field is required."}</span>}
                                        </div>
                                        <span className="kr kr-calendar" />
                                    </div> : <div className="date__fixed">
                                        <label>Return Date</label>
                                        <span>{moment(this.props.selectedDate).format("DD/MM/YYYY")}</span>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="sending-date">
                            <div
                                className={(this.props.validation.sending_date) ? "react-calendar has-error" : "react-calendar"}
                            >
                                <label className='react-calendar__label'>Sending Date <span className="asterisk">*</span></label>

                                <div data-tip="Please select Return Date first." data-for="first_return_date" className="react-calendar__field">
                                    <span className="kr kr-calendar" />
                                    <DatePicker
                                        dayClassName={date => isNonWorkingDay(date,this.props.vacationDays) || is8BusinessDayBeforeReturnDate(date,this.props.businessDaysBeforeReturnDate) ? 'disabled_date' : ''}
                                        popperPlacement="bottom"
                                        ref="picker"
                                        disabled={this.props.guideRun === false || !(this.props.data.date_of_return || this.props.selectedDate)}
                                        className="datePickerInput custom-input"
                                        selected={this.props.data.sending_date}
                                        onChange={(sendingDate) => this.props.handleChangeSendingDate(sendingDate)}
                                        placeholderText={"Select sending date"}
                                        dateFormat="DD/MM/YYYY"
                                        maxDate={this.getMinSubmissionDate()}
                                        minDate={new Date()}/>
                                    {this.props.validation.sending_date &&
                                        <span className="error-message">Sending Date field is required.</span>}
                                    {!this.props.selectedDate && !this.props.data.date_of_return && <ReactTooltip id='first_return_date' place="top" type="light" effect="float"/>}
                                </div>
                            </div>
                        </div>
                        <div className="doctor">
                            {(this.props.isAdmin && !this.props.isSubcase) ?
                                <div className={(this.props.validation.dentistName || this.props.validation.dentistNotExists) ? "doctor__block has-error" : "doctor__block"}>
                                    <label className=''>Doctor <span className="asterisk">*</span></label>
                                    <div className="doctor__select">
                                        <Creatable name="dentists"
                                                   className="booking-select"
                                                   placeholder="Select dentist"
                                                   promptTextCreator={(name) => `Add ${name}`}
                                                   style={{
                                                       boxShadow: 'none',
                                                       fontWeight: 'bold', fontSize: '16px'
                                                   }}
                                                   filterOptions={this.filterOptions}
                                                   matchPos={'start'}
                                                   value={this.props.dentistInfo}
                                                   onChange={(selectedOption) => this.props.handleChangeDentist(selectedOption)}
                                                   options={this.props.dentistsAll ?
                                                       this.props.dentistsAll.map((dentist) => ({
                                                           label: dentist.first_name + ' ' + dentist.last_name,
                                                           value: dentist.id,
                                                       })) : []}
                                        />
                                    </div>
                                    <span className="error-message">Firstname and Lastname are required.</span>
                                </div>
                                :
                                <div className="doctor__block">
                                    <label>Doctor</label>
                                    <div>{this.props.dentist}</div>
                                </div>
                            }
                        </div>
                        <div className="patient">
                            <div
                                className={
                                    (this.props.validation.patient_id) ||
                                    (this.props.validation.patient_name) ||
                                    (this.props.validation.dentistSelected) ? "patient__block has-error" : "patient__block"}
                            >
                                <label className="patient__label">Patient {!this.props.isSubcase && <span className="asterisk">*</span>}</label>
                                {this.props.isSubcase ? <div data-tip={this.props.patientList && this.props.patientList.find(item => item.id === this.props.data.patient_id) && this.props.patientList.find(item => item.id === this.props.data.patient_id).first_name + ' ' +
                                        this.props.patientList.find(item => item.id === this.props.data.patient_id) && this.props.patientList.find(item => item.id === this.props.data.patient_id).last_name} className="">
                                        {this.props.patientList && this.props.patientList.find(item => item.id === this.props.data.patient_id) && this.props.patientList.find(item => item.id === this.props.data.patient_id).first_name + ' ' +
                                            this.props.patientList.find(item => item.id === this.props.data.patient_id).last_name}
                                    </div>
                                    :
                                    <div className="patient__select">
                                        {(this.props.isAdmin) ?
                                            <Creatable name="patients"
                                                       className="booking-select"
                                                       placeholder="Select patient"
                                                       style={{
                                                           boxShadow: 'none',
                                                           fontWeight: 'bold', fontSize: '16px'
                                                       }}
                                                       filterOptions={this.filterOptions}
                                                       matchPos={'start'}
                                                       promptTextCreator={(name) => `Add ${name}`}
                                                       value={(this.props.isAdmin ? this.props.patient : this.props.data.patient_id)}
                                                       onChange={(selectedOption) => this.props.handleChangePatient(selectedOption)}
                                                       options={(this.props.isAdmin) ?
                                                           this.props.patientList && this.props.patientList.length ? this.props.patientList.filter((patient, index) => {
                                                                   if (this.props.dentistInfo && patient.dentist_id === this.props.dentistInfo.value) {
                                                                       return {
                                                                           value: patient.id,
                                                                           label: patient.first_name + ' ' + patient.last_name
                                                                       }
                                                                   }
                                                               }).map(patient => ({
                                                                   value: patient.id,
                                                                   label: patient.first_name + ' ' + patient.last_name
                                                               })) :
                                                               this.props.patientList
                                                                   .map(patient => ({
                                                                       value: patient.id,
                                                                       label: patient.first_name + ' ' + patient.last_name
                                                                   }))
                                                           :
                                                           this.props.patientList.map((patient, index) => ({
                                                               value: patient.id,
                                                               label: patient.first_name + ' ' + patient.last_name
                                                           }))
                                                       }
                                            /> :
                                            <Select name="patients"
                                                    className="booking-select"
                                                    placeholder="Select patient"
                                                    disabled={this.props.guideRun === false}
                                                    style={{
                                                        boxShadow: 'none',
                                                        fontWeight: 'bold', fontSize: '16px'
                                                    }}
                                                    matchPos={'start'}
                                                    filterOptions={this.filterOptions}
                                                    value={this.props.data.patient_id}
                                                    onChange={(selectedOption) => this.props.handleChangePatient(selectedOption)}
                                                    options={this.props.patientList && this.props.patientList.map((patient, index) => ({
                                                        value: patient.id,
                                                        label: patient.first_name + ' ' + patient.last_name
                                                    }))
                                                    }
                                            />
                                        }
                                        {this.props.validation.patient_id && <span className="error-message">Patient field is required.</span>}
                                        {this.props.validation.patient_name && <span className="error-message">Firstname and Lastname are required.</span>}
                                        {this.props.validation.dentistSelected && <span className="error-message">PLease fill the "Dr." field.</span>}
                                    </div>}
                            </div>
                            <div className="patient__add">
                                {(this.props.isAdmin || this.props.isSubcase) ||
                                    <a onClick={() => this.props.addNewPatient(this.props.guideRun)}><span
                                        className="kr kr-plus booking-add-new"/>
                                        Add new patient
                                    </a>
                                }
                            </div>
                        </div>
                        <div className="type">
                            <div className={(this.props.validation.type) ? "type__block has-error" : "type__block"}>
                                <label className='type__label'>Type <span className="asterisk">*</span></label>
                                <div className="type__select">
                                    <Select name="types"
                                            className="booking-select"
                                            placeholder="Select Type"
                                            style={{
                                                boxShadow: 'none',
                                                fontWeight: 'bold', fontSize: '16px'
                                            }}
                                            disabled={this.props.guideRun === false}
                                            matchPos={'start'}
                                            value={this.props.data.type}
                                            onChange={(selectedOption) => this.props.handleChange('type', selectedOption)}
                                            options={[
                                                { label: 'Prototype', value: 'prototype', disabled: !this.props.isAdmin && this.props.disableMiscType },
                                                { label: 'Zirconia', value: 'zirconia', disabled: !this.props.isAdmin && this.props.disableZirconiaType },
                                                { label: 'Ceramic', value: 'ceramic', disabled: !this.props.isAdmin && this.props.disableZirconiaType},
                                                { label: 'Temp', value: 'temp', disabled: !this.props.isAdmin && this.props.disableMiscType },
                                                { label: 'Other', value: 'other', disabled: !this.props.isAdmin && this.props.disableMiscType },
                                            ]}
                                    />
                                </div>
                                <span className="error-message">Type is required.</span>
                            </div>
                        </div>
                        <div className="total-units">
                            <div className="total-units__block">
                                <div
                                    className={(this.props.validation.number_of_units) || (this.props.numberOfUnits < 0) ? "text-field has-error" : "text-field"}
                                >
                                    <label className="text-field__label" htmlFor="">Total no. of units <span className="asterisk">*</span></label>
                                    <input
                                        className="text-field__input"
                                        disabled={this.props.guideRun === false}
                                        type="number"
                                        placeholder="0"
                                        value={this.props.data.number_of_units.toString().replace(/^0+/, '')}
                                        onChange={(e) => this.props.handleChange('number_of_units', e.target.value)}
                                    />
                                    {(this.props.validation.number_of_units) ? (this.props.numberOfUnits < 0) ?
                                        <span className="error-message">Please enter a valid number.</span> :
                                        <span className="error-message">Number of units field is required.</span> : ''}
                                </div>
                                <div className="units__available">
                                    {this.renderAvailableUnits()}
                                </div>
                            </div>
                            <div
                                className={this.props.validation.implant ? "total-units__block has-error" : "total-units__block"}
                            >
                                <div className="implant">
                                    <label className="implant__label">Implant <span className="asterisk">*</span></label>
                                    <div className="implant__radio">
                                        <div check="true" className="radio-button custom-control custom-radio">
                                            <input
                                                className="custom-control-input"
                                                disabled={this.props.guideRun === false}
                                                type="radio"
                                                id="cr-sub-implant-0"
                                                checked={this.props.data.implant === IMPLANT_IS_CHECKED}
                                                value={1}
                                                onChange={(e) => this.props.handleChange('implant', e.target.value)}
                                                name="implant2"
                                            />
                                            <label className="custom-control-label" htmlFor="cr-sub-implant-0">
                                                Yes
                                            </label>
                                        </div>
                                        <div check="true" className="radio-button custom-control custom-radio">
                                            <input
                                                className="custom-control-input"
                                                disabled={this.props.guideRun === false}
                                                type="radio"
                                                id="cr-sub-implant-1"
                                                checked={this.props.data.implant === '0'}
                                                value={0}
                                                onChange={(e) => this.props.handleChange('implant', e.target.value)}
                                                name="implant2"
                                            />
                                            <label className="custom-control-label" htmlFor="cr-sub-implant-1">
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                {this.props.validation.implant && <span className="error-message">Implant must be yes or no.</span>}
                            </div>
                        </div>
                        <div className="upload">
                            <Images
                                images={this.props.data.image}
                                hasErrorImages={this.props.hasErrorImages}
                                handleChange={(event, type) => this.props.handleChange(event, type)}
                                removeImage={(filename) => this.props.removeImage(filename)}
                                isBookingForm={true}
                                isForm={true}
                            />
                        </div>
                    </div>
                    <div className="book__block">
                        <div className="add-info-title">
                            <h6>Additional information</h6>
                        </div>
                        <div className="color">
                            <div
                                className="text-field"
                            >
                                <label className="text-field__label" htmlFor="">Color</label>
                                <input
                                    className="text-field__input"
                                    disabled={this.props.guideRun === false}
                                    value={this.props.data.color}
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => this.props.handleChange('color', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="cases-notes">
                            <div
                                className="text-field textarea"
                            >
                                <label className="text-field__label" htmlFor="">Case notes</label>
                                <div className={`textarea__block ${this.state.isTextareaFocused ? 'textarea__block--focused' : ''}`}>
                            <textarea
                                className="text-field__input"
                                onFocus={() => this.setState({ isTextareaFocused: true })}
                                onBlur={() => this.setState({ isTextareaFocused: false })}
                                value={this.props.data.notes}
                                disabled={this.props.guideRun === false}
                                onChange={(e) => this.props.handleChange('notes', e.target.value)} rows={3}
                            />
                                </div>
                            </div>
                        </div>
                        {this.props.isAdmin &&
                            <div className="admin-notes">
                                <div
                                    className="text-field textarea"
                                >
                                    <label className="text-field__label" htmlFor="">Notes for Lab Admin</label>
                                    <div
                                        className={`textarea__block ${this.state.isTextareaFocusedForAdmin ? 'textarea__block--focused' : ''}`}>
                                <textarea
                                    className="text-field__input"
                                    onFocus={() => this.setState({isTextareaFocusedForAdmin: true})}
                                    onBlur={() => this.setState({isTextareaFocusedForAdmin: false})}
                                    onChange={(e) => this.props.handleChange('admin_case_notes', e.target.value)}
                                    value={this.props.data && this.props.data.admin_case_notes}
                                    rows={3}
                                />
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="signature">
                            <div
                                className="text-field"
                            >
                                <label className="text-field__label" htmlFor="">Signature</label>
                                <input
                                    className="text-field__input"
                                    disabled={this.props.guideRun === false}
                                    value={this.props.data.signature}
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => this.props.handleChange('signature', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="license">
                            <div
                                className="text-field"
                            >
                                <label className="text-field__label" htmlFor="">License</label>
                                <input
                                    className="text-field__input"
                                    disabled={this.props.guideRun === false}
                                    value={this.props.hasLicense ? this.props.hasLicense : this.state.hasLicense ? this.state.hasLicense : this.props.data.license}
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => this.props.handleChange('license', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="book__block">
                        <div className="enclosed">
                            <h6 className="enclosed__title">Enclosed in the box <span className="asterisk">*</span></h6>
                            {
                                Object.keys(this.props.enclosedBoxObject).map((value, index) => {
                                    let find = this.props.enclosedBox.find(item => {
                                        return (item === value)
                                    })
                                    return (
                                        <div key={index} className="enclosed__list">
                                            <div check="true" className="checkbox custom-control custom-checkbox">
                                                <input
                                                    id={this.props.enclosedBoxObject[value].name.replace(/\s|\//g, '_')}
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    name="type"
                                                    value={value}
                                                    onChange={(e) => this.props.handleChange('enclosedBox', e.target.value)}
                                                    disabled={this.props.guideRun === false}
                                                    checked={find !== undefined ? true : false}
                                                />
                                                <label
                                                    htmlFor={this.props.enclosedBoxObject[value].name.replace(/\s|\//g, '_')}
                                                    className="checkbox-label custom-control-label"
                                                >
                                                    {this.props.enclosedBoxObject[value].name}
                                                </label>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {this.props.validation.enclosedBox && <FormText><span className="error-message">Choose at least one of the above.</span></FormText>}
                        </div>
                        {this.props.data.implant === IMPLANT_IS_CHECKED && <Fragment>
                            <div className="implant-block">
                                <div
                                    className="text-field"
                                >
                                    <label className="text-field__label" htmlFor="">Implant Type</label>
                                    <input
                                        className="text-field__input"
                                        disabled={this.props.guideRun === false}
                                        value={this.props.data.implantType}
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => this.props.handleChange('implantType', e.target.value)}
                                    />
                                </div>
                                <div
                                    className="text-field"
                                >
                                    <label className="text-field__label" htmlFor="">Implant Size</label>
                                    <input
                                        className="text-field__input"
                                        disabled={this.props.guideRun === false}
                                        value={this.props.data.implantSize}
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => this.props.handleChange('implantSize', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="parts">
                                <h6 className="parts__title">Implant Parts:</h6>
                                {
                                    Object.keys(this.props.implantsPartObject).map((value, index) => {
                                        let find = Object.keys(this.props.implantsPart).find(item => {
                                            return (item === value)
                                        })
                                        return (
                                            <div key={index} className="parts__list">
                                                <div check="true" className="checkbox custom-control custom-checkbox">
                                                    <input
                                                        id={this.props.implantsPartObject[value].name.replace(/\s|\//g, '__')}
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        name="type"
                                                        value={value}
                                                        onChange={(e) => this.props.handleChange('implantParts', e.target.value)}
                                                        disabled={this.props.guideRun === false}
                                                        checked={this.props.data.implantParts[value] !== undefined ? true : false}
                                                    />
                                                    <label
                                                        htmlFor={this.props.implantsPartObject[value].name.replace(/\s|\//g, '__')}
                                                        className="checkbox-label custom-control-label"
                                                    >
                                                        {this.props.implantsPartObject[value].name}
                                                    </label>
                                                </div>
                                                {(find !== undefined) ?
                                                    <div
                                                        className={`text-field ${this.props.validation.implantParts ? "has-error" : ""}`}
                                                    >
                                                        <input
                                                            className="text-field__input"
                                                            value={this.props.data.implantParts[find]}
                                                            type="number"
                                                            onChange={(e) => this.props.handleChange('implantParts', e.target.value, find)}
                                                        />
                                                        {this.props.validation.implantParts && <span className="error-message">Required</span>}

                                                    </div> : ''}

                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Fragment>}
                    </div>
                </div>
                <div className="print-bridge" ref={this.props.bridgesRef}>
                    <div className="print-bridge__container">
                        <div className="print-bridge__block">
                            <div className='t-left'>
                                {
                                    Object.keys(this.state.bridgesStructure.top.left).map((key)=>{
                                        return <Fragment>
                                            <div className={`t-item ${this.props.checkedTeeth && this.props.checkedTeeth.includes(this.state.bridgesStructure.top.left[key].number) ? 'checked' : ''}`} onClick={()=>this.props.makeBridge(this.state.bridgesStructure.top.left[key].number,this.state.bridgesStructure.top.left[key].number)}>
                                                {this.state.bridgesStructure.top.left[key].number}
                                            </div>
                                            {this.state.bridgesStructure.top.left[key].number !== 18 && <span
                                                className={
                                                    `${bridges && bridges.some(item => item.from === this.state.bridgesStructure.top.left[key].number && item.to === this.state.bridgesStructure.top.left[key].number+1) && 'checked_bridge'}
                                                     bottom-bridge ${bridges && bridges.map((item)=>{if(item.from ===this.state.bridgesStructure.top.left[key].number && item.to === this.state.bridgesStructure.top.left[key].number+1){ return 'checked_bridge'}})}
                                                     ${'bottom-bridge-' + this.state.bridgesStructure.top.left[key].number + '-' + parseFloat(this.state.bridgesStructure.top.left[key].number + 1)}`}
                                                onClick={() => this.props.makeBridge(this.state.bridgesStructure.top.left[key].number, this.state.bridgesStructure.top.left[key].number + 1)}
                                            >
                                            </span>}
                                        </Fragment>

                                    })
                                }
                            </div>
                            <div className="t-center">
                                {
                                    Object.keys(this.state.bridgesStructure.top.center).map((key)=>{
                                        return <Fragment>
                                            {
                                                this.state.bridgesStructure.top.center[key].number === 12 &&
                                                <span
                                                    className={`
                                                    ${bridges && bridges.some(item => item.from === this.state.bridgesStructure.top.center[key].number && item.to === this.state.bridgesStructure.top.center[key].number+1) && 'checked_bridge'}
                                                    ${this.state.bridgesStructure.top.center[key].number === 12 && 'left-bridge'} right-bridge ${'right-bridge-'+this.state.bridgesStructure.top.center[key].number+'-'+parseFloat(this.state.bridgesStructure.top.center[key].number + 1)}`}
                                                    onClick={()=>this.props.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number+1)}
                                                />
                                            }
                                            <div className={`t-item ${this.props.checkedTeeth && this.props.checkedTeeth.includes(this.state.bridgesStructure.top.center[key].number) ? 'checked' : ''}`} onClick={()=>this.props.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number)}>
                                                {this.state.bridgesStructure.top.center[key].number}
                                            </div>
                                            <span
                                                className={`
                                                ${bridges && bridges.some(item => this.state.bridgesStructure.top.center[key].number === 11 ? item.from === 11 && item.to === 21 : item.from === this.state.bridgesStructure.top.center[key].number && item.to === this.state.bridgesStructure.top.center[key].number+1 && item.to !== 13) && 'checked_bridge'}
                                                ${bridges && bridges.some(item => this.state.bridgesStructure.top.center[key].number === 12 && item.from === 12 && item.to === 11 ) && 'checked_bridge'}
                                                ${this.state.bridgesStructure.top.center[key].number === 12 && 'left-bridge'} right-bridge ${'right-bridge-'+this.state.bridgesStructure.top.center[key].number+'-'+parseFloat(this.state.bridgesStructure.top.center[key].number + 1)}`}
                                                onClick={()=>this.state.bridgesStructure.top.center[key].number === 12 ? this.props.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number-1) : this.props.makeBridge(this.state.bridgesStructure.top.center[key].number,this.state.bridgesStructure.top.center[key].number+1)}
                                            />
                                        </Fragment>

                                    })
                                }
                                <div className="u-title">Upper Jaw</div>
                            </div>
                            <div className="t-right">
                                {
                                    Object.keys(this.state.bridgesStructure.top.right).map((key)=>{
                                        return <Fragment>
                                            <div className={`t-item ${this.props.checkedTeeth && this.props.checkedTeeth.includes(this.state.bridgesStructure.top.right[key].number) ? 'checked' : ''}`} onClick={()=>this.props.makeBridge(this.state.bridgesStructure.top.right[key].number,this.state.bridgesStructure.top.right[key].number)}>
                                                {this.state.bridgesStructure.top.right[key].number}
                                            </div>
                                            {this.state.bridgesStructure.top.right[key].number !== 28 && <span
                                                className={`
                                                    ${bridges && bridges.some(item => item.from === this.state.bridgesStructure.top.right[key].number && item.to === this.state.bridgesStructure.top.right[key].number+1) && 'checked_bridge'}
                                                    bottom-bridge ${'bottom-bridge-' + this.state.bridgesStructure.top.right[key].number + '-' + parseFloat(this.state.bridgesStructure.top.right[key].number + 1)}`}
                                                onClick={() => this.props.makeBridge(this.state.bridgesStructure.top.right[key].number, this.state.bridgesStructure.top.right[key].number + 1)}
                                            >
                                            </span>}
                                        </Fragment>

                                    })
                                }
                            </div>
                        </div>
                        <div className="print-bridge__block">
                            <div className='t-left'>
                                {
                                    Object.keys(this.state.bridgesStructure.bottom.left).map((key)=>{
                                        return <Fragment>
                                            <div className={`t-item ${this.props.checkedTeeth && this.props.checkedTeeth.includes(this.state.bridgesStructure.bottom.left[key].number) ? 'checked' : ''}`} onClick={()=>this.props.makeBridge(this.state.bridgesStructure.bottom.left[key].number,this.state.bridgesStructure.bottom.left[key].number)}>
                                                {this.state.bridgesStructure.bottom.left[key].number}
                                            </div>
                                            {this.state.bridgesStructure.bottom.left[key].number !== 43 && <span
                                                className={`${bridges && bridges.some(item => item.from === this.state.bridgesStructure.bottom.left[key].number-1 && item.to === this.state.bridgesStructure.bottom.left[key].number) && 'checked_bridge'}
                                                bottom-bridge ${'bottom-bridge-' + this.state.bridgesStructure.bottom.left[key].number + '-' + parseFloat(this.state.bridgesStructure.bottom.left[key].number + 1)}`}
                                                onClick={() => this.props.makeBridge(this.state.bridgesStructure.bottom.left[key].number-1, this.state.bridgesStructure.bottom.left[key].number)}
                                            >
                                            </span>}
                                        </Fragment>

                                    })
                                }
                            </div>
                            <div className="t-center">
                                {
                                    Object.keys(this.state.bridgesStructure.bottom.center).map((key)=>{
                                        return <Fragment>
                                            {
                                                this.state.bridgesStructure.bottom.center[key].number === 42 &&
                                                <span
                                                    className={`${bridges && bridges.some(item => item.from === this.state.bridgesStructure.bottom.center[key].number && item.to === this.state.bridgesStructure.bottom.center[key].number+1) && 'checked_bridge'}
                                                    ${this.state.bridgesStructure.bottom.center[key].number === 42 && 'left-bridge'} right-bridge ${'right-bridge-'+this.state.bridgesStructure.bottom.center[key].number+'-'+parseFloat(this.state.bridgesStructure.bottom.center[key].number + 1)}`}
                                                    onClick={()=>this.props.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number+1)}
                                                ></span>
                                            }
                                            <div className={`t-item ${this.props.checkedTeeth && this.props.checkedTeeth.includes(this.state.bridgesStructure.bottom.center[key].number) ? 'checked' : ''}`} onClick={()=>this.props.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number)}>
                                                {this.state.bridgesStructure.bottom.center[key].number}
                                            </div>
                                            <span
                                                className={`${bridges && bridges.some(item => item.from === this.state.bridgesStructure.bottom.center[key].number && item.to === this.state.bridgesStructure.bottom.center[key].number+1) && this.state.bridgesStructure.bottom.center[key].number !== 42 && 'checked_bridge'}
                                                ${bridges && bridges.some(item => this.state.bridgesStructure.bottom.center[key].number === 41 ? item.from === 41 && item.to === 31 : item.from === this.state.bridgesStructure.bottom.center[key].number && item.to === this.state.bridgesStructure.bottom.center[key].number+1 || this.state.bridgesStructure.bottom.center[key].number === 42 ? item.from === 42 && item.to === 41 : null) && 'checked_bridge'}
                                                 right-bridge ${'right-bridge-'+this.state.bridgesStructure.bottom.center[key].number+'-'+parseFloat(this.state.bridgesStructure.bottom.center[key].number + 1)}`}
                                                onClick={()=>this.state.bridgesStructure.bottom.center[key].number === 42 ? this.props.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number-1) : this.props.makeBridge(this.state.bridgesStructure.bottom.center[key].number,this.state.bridgesStructure.bottom.center[key].number+1)}
                                            >
                                            </span>
                                        </Fragment>
                                    })
                                }
                                <div className="l-title">Lower Jaw</div>
                            </div>
                            <div className="t-right">
                                {
                                    Object.keys(this.state.bridgesStructure.bottom.right).map((key)=>{
                                        return <Fragment>
                                            <div className={`t-item ${this.props.checkedTeeth && this.props.checkedTeeth.includes(this.state.bridgesStructure.bottom.right[key].number) ? 'checked' : ''}`} onClick={()=>this.props.makeBridge(this.state.bridgesStructure.bottom.right[key].number,this.state.bridgesStructure.bottom.right[key].number)}>
                                                {this.state.bridgesStructure.bottom.right[key].number}
                                            </div>
                                            {this.state.bridgesStructure.bottom.right[key].number !== 33 && <span
                                                className={`${bridges && bridges.some(item => item.from === this.state.bridgesStructure.bottom.right[key].number && item.to === this.state.bridgesStructure.bottom.right[key].number-1) && 'checked_bridge'}
                                                bottom-bridge ${'bottom-bridge-' + this.state.bridgesStructure.bottom.right[key].number + '-' + parseFloat(this.state.bridgesStructure.bottom.right[key].number + 1)}`}
                                                onClick={() => this.props.makeBridge(this.state.bridgesStructure.bottom.right[key].number, this.state.bridgesStructure.bottom.right[key].number-1)}
                                            >
                                            </span>}
                                        </Fragment>

                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }

}

const mapStateToProps = dispatch => {
    return {
        home: dispatch.home,
        caseDetails: dispatch.caseDetails,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        removeAllUploads: () => dispatch(removeAllImageUploads())
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(addBookingForm)



// WEBPACK FOOTER //
// ./src/components/Home/addBookingForm.js